import React, { Component } from 'react'
import { bindStateToProps, bindActionCreators } from 'lib'
import { connect } from 'react-redux'
import autoBind from 'auto-bind'
import _ from 'lodash'

import { actions as tableActions } from 'store/modules/table'
import { actions as helpActions } from 'store/modules/help'

import TableList from 'components/organisms/TableList'
import HelpContainer from 'containers/HelpContainer'

import { isEmptyObject, isFunction, isObject, isNumber } from 'lib/detectType'
import isEqualProps from 'lib/isEqualProps'

class TableContainer extends Component {
  constructor(props) {
    super(props)
    autoBind(this)
    this.state = {
      moreDataLoading: false
    }
  }

  componentDidMount() {
    const isTableReady = this.props.initFlag?.[this.props.tableKey] === true
    if (isTableReady) {
      this.loadCallback()
    }
    this.initHelpMessage()
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {
      tableKey,
      initFlag = {},
      originData = {},
      data = {},
      options = {},
      checked = {}
    } = this.props
    const {
      initFlag: nextInitFlag = {},
      originData: nextOriginData = {},
      data: nextData = {},
      options: nextOptions = {},
      checked: nextChecked = {},
      updateFlag = {}
    } = nextProps
    const next =
      updateFlag?.[tableKey] ||
      !isEqualProps(nextProps, this.props, [
        'maxHeight',
        'focusRow',
        'loading'
      ]) ||
      !isEqualProps(nextState, this.state, ['moreDataLoading']) ||
      !isEqualProps(
        {
          initFlag: nextInitFlag?.[tableKey],
          checked: nextChecked?.[tableKey],
          options: nextOptions?.[tableKey]
        },
        {
          initFlag: initFlag?.[tableKey],
          checked: checked?.[tableKey],
          options: options?.[tableKey]
        }
      ) ||
      !isEqualProps(
        {
          length: nextData?.[tableKey]?.length,
          originLength: nextOriginData?.[tableKey]?.length
        },
        {
          length: data?.[tableKey]?.length,
          originLength: originData?.[tableKey]?.length
        }
      ) ||
      !isEqualProps(
        { data: nextOriginData?.[tableKey] },
        { data: originData?.[tableKey] }
      ) ||
      !isEqualProps(nextProps, this.props, ['sideEl'])
    return next
  }

  async componentDidUpdate(prevProps, prevState) {
    const { tableKey, initFlag = {}, data = {}, options = {} } = this.props
    const {
      initFlag: prevInitFlag = {},
      data: prevData = {},
      options: prevOptions = {}
    } = prevProps
    // init help message
    this.initHelpMessage()
    if (initFlag?.[tableKey] === true && prevInitFlag?.[tableKey] !== true) {
      return this.loadCallback()
    }
    const { page, rowsPerPage } = options?.[tableKey] || {}
    const { page: prevPage, rowsPerPage: prevRowsPerPage } =
      prevOptions?.[tableKey] || {}
    const dataLength = data?.[tableKey]?.length || 0
    const prevDataLength = prevData?.[tableKey]?.length || 0
    const isChangeDataLength = dataLength !== prevDataLength
    const toNextPage = isNumber(page) && isNumber(prevPage) && page > prevPage
    const isChangeLimit =
      isNumber(rowsPerPage) &&
      isNumber(prevRowsPerPage) &&
      rowsPerPage !== prevRowsPerPage
    const isNeedMoreData = isChangeDataLength || toNextPage || isChangeLimit
    // load more data
    if (isNeedMoreData) {
      this.loadCallback()
    }
  }

  componentWillUnmount = () => {
    const { TableActions, tableKey, disabledCleaning } = this.props
    if (disabledCleaning !== true) {
      TableActions.uncheck({ key: tableKey })
      // TableActions.clear({ key: tableKey })
    }
  }

  initHelpMessage() {
    const { HelpActions, tableKey, columns } = this.props
    const helpColumns = _.pickBy(columns[tableKey], data => {
      return data.help && isObject(data.help)
    })
    if (!isObject(helpColumns) || isEmptyObject(helpColumns)) {
      return
    }
    HelpActions.init(
      Object.keys(helpColumns).map(helpKey => {
        const { title, description } = helpColumns[helpKey].help
        return _.omitBy(
          {
            key: tableKey + helpKey,
            title,
            description
          },
          _.isUndefined
        )
      })
    )
  }

  async loadCallback() {
    const {
      TableActions,
      tableKey,
      data = {},
      options = {},
      updateFlag = {},
      hash = {}
    } = this.props
    const {
      page,
      rowsPerPage,
      onLoadCallback,
      existsMoreDataFlag = true
    } = options[tableKey] || {}
    // 기대 수량
    const expected = (page + 1) * rowsPerPage
    // 현재 데이터 수량
    const dataLength = data?.[tableKey]?.length || 0
    if (
      isFunction(onLoadCallback) &&
      !isNaN(expected) &&
      expected >= dataLength &&
      existsMoreDataFlag &&
      !this.state.moreDataLoading
    ) {
      // 더 불러와야할 데이터 수
      const limit = Math.abs(dataLength - expected) || rowsPerPage
      await onLoadCallback(limit, dataLength, hash[tableKey])
    }
    if (updateFlag?.[tableKey] !== false) {
      TableActions.setState({
        updateFlag: Object.assign({}, updateFlag, {
          [tableKey]: false
        })
      })
    }
  }

  onRequestSort(orderBy) {
    const { TableActions, options, tableKey: key } = this.props
    const { order } = options[key]
    TableActions.checkAll({ key, checked: false })
    TableActions.setOptions({
      key,
      options: {
        order: order === 'desc' ? 'asc' : 'desc',
        orderBy
      }
    })
  }

  stableSort(array, order, orderBy) {
    const { columns = {}, tableKey } = this.props
    const defaultColumn = Object.keys(columns[tableKey] || {})[0]
    if (!defaultColumn) return array
    orderBy = orderBy || defaultColumn
    if (!order) return array
    const data = _.sortBy(array, [
      obj => {
        if (isObject(obj[orderBy]) && obj[orderBy].originData !== undefined) {
          return obj[orderBy].originData
        }
        return isObject(obj[orderBy]) && obj[orderBy].primary !== undefined
          ? obj[orderBy].primary
          : obj[orderBy]
      }
    ])
    return order === 'desc' ? data.reverse() : data
  }

  onChangePage(e, page) {
    const { TableActions, tableKey: key } = this.props
    TableActions.setOptions({
      key,
      options: { page }
    })
  }

  onChangeRowsPerPage(e) {
    const { TableActions, tableKey: key } = this.props
    // TableActions.checkAll({ key, checked: false })
    TableActions.setOptions({
      key,
      options: {
        page: 0,
        rowsPerPage: e.target.value
      }
    })
  }

  onClickCheckbox(e, index, data) {
    const { TableActions, tableKey: key } = this.props
    TableActions.toggleCheck({ key, index, data })
  }

  onClickCheckAll(e, data) {
    const { TableActions, tableKey: key } = this.props
    TableActions.checkAll({ key, checked: e.target.checked, data })
  }

  onClickCheckAllToggle(data) {
    const { TableActions, tableKey: key } = this.props
    TableActions.checkAllToggle({ key, data })
  }

  onClickUncheck() {
    const { TableActions, tableKey: key } = this.props
    TableActions.uncheck({ key })
  }

  render() {
    const {
      tableKey,
      initFlag = {},
      data = {},
      originData = {},
      columns = {},
      options = {},
      checked = {},
      focusRow = {}
    } = this.props
    return (
      <TableList
        {...this.props}
        {...this.state}
        proxy={this}
        initFlag={initFlag?.[tableKey]}
        data={data[tableKey]}
        originData={originData[tableKey]}
        columns={columns[tableKey]}
        options={options[tableKey]}
        checked={checked[tableKey]}
        focusRow={focusRow[tableKey]}
        HelpContainer={HelpContainer}
      />
    )
  }
}
export default connect(
  bindStateToProps({
    table: true
  }),
  bindActionCreators({
    helpActions,
    tableActions
  })
)(TableContainer)
